import { IFinancialProductSponsor } from './financial-product-sponsor'

export enum FinancialTermType {
  Isa = 'isa',
  FixPay = 'fix_pay',
}

export interface IFinancialTerm {
  _id: string
  name: string
  description: string
  cap: number
  percentage: number
  maturity: number
  maxPayments: number
  minThreshold: number
  status: FinancialTermStatus
  availableCountries: string[]
  dropoutPolicy?: string
  financialProductSponsor?: string | IFinancialProductSponsor
  type: FinancialTermType
  predictedIncome?: number
  administrativeFee?: number
  createdAt: string
  updatedAt: string
}

export enum FinancialTermStatus {
  Active = 'active',
  Draft = 'draft',
  Inactive = 'inactive',
}
